var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c(_vm.auth('admin').check() ? 'HeaderPage' : 'TeacherHeaderPage',{tag:"component"}),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }